import { render, staticRenderFns } from "./flightDetail.vue?vue&type=template&id=505b72d6&"
import script from "./flightDetail.vue?vue&type=script&lang=ts&"
export * from "./flightDetail.vue?vue&type=script&lang=ts&"
import style0 from "./flightDetail.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports